import { CheckoutState } from '../../state';
import { isNativeApp } from '../app';
import { isSalesClient } from '../event';
import {
    getIsPostCheckoutMandatoryQuestionsSupported,
    hasOfflinePaymentMethods,
} from '../order/typedOrderSelectors';
import { hasRequiredCannedQuestions } from '../survey/hasRequiredCannedQuestions';
import { hasRequiredCustomQuestions } from '../survey/hasRequiredCustomQuestions';
import { hasTaxQuestions } from '../survey/hasTaxQuestions';

export const isPostCheckoutMandatoryQuestionsElegible = (
    state: CheckoutState,
) =>
    !isNativeApp(state) &&
    hasRequiredCannedQuestions(state) &&
    !hasRequiredCustomQuestions(state) &&
    !hasTaxQuestions(state) &&
    getIsPostCheckoutMandatoryQuestionsSupported(state) &&
    !isSalesClient(state) &&
    !hasOfflinePaymentMethods(state);
